// ── Login Screen ──────────────────────────────────────────────────────────────
import { useAuth } from '../../../shared/auth/AuthContext';

export function LoginScreen() {
  const { doLogin } = useAuth();
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh',
      background: `radial-gradient(ellipse at 30% 40%, #00d4aa08 0%, transparent 60%),
                   radial-gradient(ellipse at 80% 70%, #0099ff06 0%, transparent 60%),
                   var(--bg)`,
    }}>
      <div style={{
        width: 360, background: 'var(--surface)', border: '1px solid var(--border2)',
        borderRadius: 12, padding: '40px 36px', position: 'relative', overflow: 'hidden',
      }}>
        {/* Top accent line */}
        <div style={{
          position: 'absolute', top: 0, left: 0, right: 0, height: 2,
          background: 'linear-gradient(90deg, var(--accent), var(--accent2))',
        }} />
        <div style={{ fontWeight: 800, fontSize: 20, letterSpacing: '-0.5px', marginBottom: 4 }}>
          Waste<span style={{ color: 'var(--accent)' }}>cloud</span>
        </div>
        <div style={{ fontFamily: 'var(--mono)', fontSize: 12, color: 'var(--muted)', marginBottom: 20 }}>
          platform admin · internal
        </div>
        <p style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.6, marginBottom: 28 }}>
          Συνδέσου με τον Wastecloud administrator λογαριασμό σου.
        </p>
        <button className="btn btn-primary btn-full" onClick={doLogin}>
          Login with Keycloak
        </button>
      </div>
    </div>
  );
}
